var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instructor-profile section-holder"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('instructor_profile.course_taught_by')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "user-details"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.$t('instructor_profile.instructor_name')))]), _vm._v(" "), _c('div', {
    staticClass: "user-title"
  }, [_vm._v(_vm._s(_vm.$t('instructor_profile.designation')))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "user-title"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('instructor_profile.view_profile')) + " ")])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/user.png",
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rating-star"
  }, [_c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "mdi mdi-star-half",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" (234 votes)")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53bd2c19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/instructorProfile.vue
// module id = SUk2
// module chunks = 1